import { useEffect } from "react";
import { useQueryClient, type QueryKey } from "@tanstack/react-query";
import { requestUnavailable } from "@softmax/observatory-client/transport";

export function useDiscardUnavailableData({
  queryKey,
  error,
}: {
  readonly queryKey: QueryKey;
  readonly error: Error | null;
}) {
  const client = useQueryClient();
  const query = client.getQueryCache().find({ queryKey, exact: true });
  const unavailable = requestUnavailable(error);
  useEffect(() => {
    if (query && requestUnavailable(error))
      void client
        .cancelQueries({ queryKey: query.queryKey, exact: true })
        .then(() => {
          if (query.state.data !== undefined)
            query.setState({ data: undefined, dataUpdatedAt: 0 });
        });
  }, [client, query, error]);
  return unavailable;
}
